import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Language} from '../../../intl/interfaces/language';

@Component({
  selector: 'app-language-selection-item',
  templateUrl: './language.selection.item.component.html',
  styleUrls: ['./language.selection.item.component.scss']
})
export class LanguageSelectionItemComponent {
  @Input() language: Language;
  @Input() selected: boolean;
  @Input() indented: boolean = false;

  @Output() languageSelected: EventEmitter<Language> = new EventEmitter<Language>();
}
